import React from 'react';
import Box from '@mui/material/Box';

/**
 * Section divider component with text label
 * @param {string} text - Label text to display in the divider
 * @param {boolean} isFirst - If true, removes top padding
 */
const Divider = ({ text, isFirst = false }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        color: 'primary.main',
        fontSize: { xs: '14px', sm: '16px' },
        paddingTop: isFirst ? 0 : '1em',
      }}
    >
      <Box
        sx={{
          borderTop: '1px dashed',
          borderColor: 'primary.main',
          height: 0,
          flex: 1,
          marginRight: { xs: '8px', sm: '10px' },
        }}
      />
      <Box
        component="span"
        sx={{
          whiteSpace: 'nowrap',
          fontSize: { xs: '13px', sm: '16px' },
        }}
      >
        {text}
      </Box>
      <Box
        sx={{
          borderTop: '1px dashed',
          borderColor: 'primary.main',
          height: 0,
          flex: 7,
          marginLeft: { xs: '8px', sm: '10px' },
        }}
      />
    </Box>
  );
};

export default Divider;

